import React from 'react';
import { connect } from 'react-redux';
import { FlatButton, CircularProgress } from 'material-ui';
import RefreshIcon from 'material-ui/svg-icons/navigation/refresh';
import CheckIcon from 'material-ui/svg-icons/navigation/check';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import { POST_STEPS, STATUS_STATES } from '../../../../../config/postConstants';
import { addToQuery } from 'dash-front/helpers';
import { retrySendPost } from 'dash-front/campaign/actions/posts';

const isPostFailed = post =>
    post.status.state === STATUS_STATES.FAILED && post.status.step !== POST_STEPS.AWAITING_FOR_MODERATION;

const isAwaitingModeration = post =>
    post.status.step === POST_STEPS.AWAITING_FOR_MODERATION && post.status.state === STATUS_STATES.STARTED;

const isRejected = post =>
    post.status.step === POST_STEPS.AWAITING_FOR_MODERATION && post.status.state === STATUS_STATES.FAILED;

const isDeleted = post =>
    post.status.step === POST_STEPS.DELETE_POST_RESULT && post.status.state === STATUS_STATES.SUCCESS;

const isDeleting = post =>
    post.status.step === POST_STEPS.DELETE_POST_RESULT &&
    [STATUS_STATES.STARTED, STATUS_STATES.AWAITING].some(s => post.status.state === s);

const isFinishedPosting = post =>
    post.status.step === POST_STEPS.FINISHED && post.status.state === STATUS_STATES.SUCCESS;

const canRetry = post => isPostFailed(post) && post.status.attempts >= 3;

const approve = id => () => {
    addToQuery('publish', id);
};

const reject = id => () => {
    addToQuery('reject', id);
};

const deletePost = id => () => {
    addToQuery('delete', id);
};

// const openLogs = id => () => {
//     addToQuery('logs', id);
// };

const PostActions = connect(null, dispatch => ({
    retry: id => dispatch(retrySendPost(id))
}))(({ post, retry }) => {
    if (!post) {
        return null;
    }
    const { _id: id } = post;
    const canBeRetried = canRetry(post);
    const deleting = isDeleting(post);
    if (canBeRetried || deleting) {
        return (
            <div>
                <FlatButton
                    primary
                    disabled={!canBeRetried}
                    label={'Retry'}
                    icon={<RefreshIcon />}
                    onTouchTap={() => retry(id)}
                    style={{ width: '50%' }}
                />
                <FlatButton
                    secondary
                    disabled={deleting}
                    onTouchTap={deletePost(id)}
                    icon={deleting ? <CircularProgress size={20} thickness={2.5} /> : <DeleteIcon />}
                    label={'Delete'}
                    style={{ width: '50%' }}
                />
            </div>
        );
    }
    const awaiting = isAwaitingModeration(post);
    const deleted = isDeleted(post);
    const rejected = isRejected(post);
    const finished = isFinishedPosting(post);
    const inPostingProcess = !awaiting && !deleting && !rejected && !deleted && !finished;
    return (
        <div>
            <FlatButton
                primary
                icon={inPostingProcess ? <CircularProgress size={20} thickness={2.5} /> : <CheckIcon />}
                disabled={!awaiting}
                label={'Approve'}
                onTouchTap={approve(id)}
                style={{ width: '50%' }}
            />
            <FlatButton
                secondary
                icon={<DeleteIcon />}
                onTouchTap={reject(id)}
                disabled={!awaiting}
                label={'Reject'}
                style={{ width: '50%' }}
            />
        </div>
    );
});

export default PostActions;



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/containers/Posts/PostActions.js
 **/